module.exports = __webpack_public_path__ + "img/icon_sm_jpqr.02e03bbf.png";